export const getAppTitle = () => {
  const appType = process.env.REACT_APP_TYPE;
  let headingAppName = '';

  switch (appType) {
    case 'EV':
      headingAppName = 'Evidenca vrednotenja';
      break;
    case 'JV':
      headingAppName = 'Javni vpogled';
      break;
    case 'OV':
      headingAppName = 'Osebni vpogled';
      break;
    default:
      headingAppName = 'Evidenca vrednotenja';
      break;
  }
  return headingAppName;
};
